import { FiArrowRight, FiShield } from "react-icons/fi";

export const TwoFactorPromoBanner = ({ onOpenSettings }) => (
  <div
    className="individual-account-banner individual-account-banner--interactive"
    role="button"
    tabIndex={0}
    onClick={onOpenSettings}
    onKeyDown={(event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onOpenSettings?.();
      }
    }}
  >
    <div className="individual-account-banner__icon">
      <FiShield className="h-5 w-5" />
    </div>

    <div className="individual-account-banner__body">
      <p className="individual-account-banner__title">
        Configure a autenticação de dois fatores na sua conta
      </p>
      <p className="individual-account-banner__description">
        Escolha até três métodos de verificação para proteger o acesso e as
        operações sensíveis.
      </p>
    </div>

    <span className="individual-account-banner__cta">
      Configurar
      <FiArrowRight className="h-4 w-4" />
    </span>
  </div>
);
